import { render, staticRenderFns } from "./MetaIcon.vue?vue&type=template&id=67e84c14&scoped=true"
import script from "./MetaIcon.vue?vue&type=script&lang=js"
export * from "./MetaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e84c14",
  null
  
)

export default component.exports